import clsx from 'clsx';
import { Icon } from 'ui';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import useInputGrades from './useInputGrades';

const InputGrades = ({
  ariaLabel,
  onChange,
  placeholder,
  type = 'text',
  disabled = false,
  referer,
  size = 'default',
  pointsTotal = 10,
  isScoreReadOnly,
  max,
  min,
  showDotted = false,
  isLate = false,
  scoreScale,
  t,
  ...props
}) => {
  const { accessibleName, value, hasError, onChangeText, onFocus, onBlur } = useInputGrades({ ariaLabel, props, max, onChange, pointsTotal, scoreScale, t });

  return (
    <div className={clsx('input-points', { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <input
          aria-label={accessibleName}
          className={clsx('input-points__input', { 'input-points__input--disabled': disabled })}
          type={type}
          placeholder={placeholder}
          onChange={onChangeText}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          ref={referer}
          readOnly={isScoreReadOnly}
          max={max}
          min={min}
          value={value}
        />
        {isLate && (
          <div className="input-points__late">
            <TooltipCustom title={t('lesson:Delivered late')} placement="top" hasArrow>
              <div>
                <Icon name="exclamation-circle" />
              </div>
            </TooltipCustom>
          </div>
        )}
        <span className="input-points__points-total">/{pointsTotal}</span>
      </div>
    </div>
  );
};

InputGrades.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  isLate: PropTypes.bool,
  isScoreReadOnly: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  pointsTotal: PropTypes.number,
  referer: PropTypes.object,
  scoreScale: PropTypes.string,
  showDotted: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  t: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputGrades;
